import { render, staticRenderFns } from "./App.vue?vue&type=template&id=0a7b5aba&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=0a7b5aba&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=0a7b5aba&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b5aba",
  null
  
)

export default component.exports